var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c('v-chip',[(_vm.failed)?_c('v-icon',{attrs:{"small":"","left":""},domProps:{"textContent":_vm._s(_vm.icons.warning)}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")],1),_vm._v(" "),_c('v-badge',{attrs:{"offset-x":_vm.count < 10 ? 24 : 28,"offset-y":"-8","content":_vm.count,"value":_vm.showBadge}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }